<template>
    <BaseButton
        v-bind="props"
        :class="[$style.default_button_override, sizesStyles[`size_${props.size}`]]"
    >
        <Icon
            v-if="props.leftIcon"
            :name="props.leftIcon"
            :class="sizesStyles.left_icon"
        />
        <Typography
            v-if="props.label"
            type="label"
            :responsive="false"
            v-bind="labelBindings"
            :class="$style.label_override"
        >
            {{ props.label }}
        </Typography>
        <slot />
    </BaseButton>
</template>

<script lang="ts" setup>
import { type HTMLAttributes } from 'vue'

import { type IconNameType } from '@/components/Icon'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'

import BaseButton, { BaseButtonProps } from './components/BaseButton.vue'
import { useLabelBindings } from './composables/use-label-bindings'
import sizesStyles from './styles/sizes.module.css'

type Props = {
    leftIcon?: IconNameType
    label?: string | number
} & BaseButtonProps &
    /* @vue-ignore */ Omit<HTMLAttributes, 'hidden'>

const props = withDefaults(defineProps<Props>(), {
    type: 'button',
    size: 'm',
    width: 'normal',
    color: 'purple-400',
})

const { labelBindings } = useLabelBindings(props.size)
</script>
<style module>
.default_button_override {
    color: var(--text);
    --background-color: var(--main);
}

.default_button_override:not(:disabled):hover:before {
    background-image: var(--gradient);
    filter: var(--filter);
    box-shadow: var(--box-shadow);
    transition: all 0.2s;
}

.default_button_override:not(:disabled):active:before {
    filter: brightness(0.92);
}

.default_button_override:disabled {
    color: var(--white-40);
    --background-color: var(--carbon-400);
}

.label_override {
    line-height: 100%;
}
</style>
